// Clears the URL bar of universal login return data
export default () =>
  typeof window !== "undefined" &&
  window.history.replaceState({}, document.title, window.location.href.split(/(#|\?)(access_token|error)/)[0]);
